import { produce } from 'immer';

import {
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS,
  DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE,
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_CHANGE,
  DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_INSERTED,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';
import { RequesterTextField as ContractSetupRequesterImageField } from '@app/store/contract-setup/RequesterField';
import RequesterFieldType from '@app/store/contract-setup/RequesterFieldType';
import { DocumentSetupAction } from '@app/store/documentSetup/actions';
import RequesterImageField from '@app/store/documentSetup/RequesterImageField';

export type DocumentSetupLastRequesterImageFieldState = RequesterImageField | null;

const initialState: DocumentSetupLastRequesterImageFieldState = null;

export default function reducer(
  state: DocumentSetupLastRequesterImageFieldState = initialState,
  action: DocumentSetupAction | ContractSetupAction
): DocumentSetupLastRequesterImageFieldState {
  switch (action.type) {
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_REQUEST:
    case DOCUMENT_SETUP__REQUESTER_FIELDS_PAGE_OVER_DELETE:
    case DOCUMENT_SETUP_CLEAR_ALL_STATE:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_FIELDS_FETCH_SUCCESS: {
      const { requesterFields } = action.payload;

      const requesterImageField = requesterFields.find(
        (requesterField): requesterField is ContractSetupRequesterImageField =>
          requesterField.inputType === RequesterFieldType.IMAGE_FIELD
      );

      if (requesterImageField) {
        const { id, positionX, positionY, positionZ, positionPage, sizeHeight, sizeWidth } =
          requesterImageField;
        return {
          id,
          pageNumber: positionPage,
          type: 'image',
          values: {
            dataLabel: '',
            fileId: null,
            fileOtp: null,
            fileUrl: null,
            height: sizeHeight,
            imageSrc: null,
            width: sizeWidth,
            x: positionX,
            y: positionY,
            z: positionZ,
          },
        };
      }
      return null;
    }
    case DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_CHANGE:
      return produce(state, (draft) => {
        const { id, values } = action.payload;
        const { height, width, x, y, z } = values;
        if (draft?.id === id) {
          draft.values = {
            dataLabel: '',
            fileId: null,
            fileOtp: null,
            fileUrl: null,
            height,
            imageSrc: null,
            width,
            x,
            y,
            z,
          };
        }
      });
    case DOCUMENT_SETUP_REQUESTER_IMAGE_FIELD_INSERTED: {
      const { id, type, pageNumber, values } = action.payload;
      const { height, width, x, y, z } = values;
      return {
        id,
        type,
        pageNumber,
        values: {
          dataLabel: '',
          fileId: null,
          fileOtp: null,
          fileUrl: null,
          height,
          imageSrc: null,
          width,
          x,
          y,
          z,
        },
      };
    }
    default:
      return state;
  }
}
